<template>
  <div class="row">
    <div class="col-12 col-md-4 col-xl-2 mb-3">
      <label class="form-label text-theme">Rango de fechas</label>
      <datepicker
        id="datepicker1"
        range
        multiCalendars
        :enable-time-picker="false"
        :format-locale="es"
        v-model="rangoFechas"
        placeholder=""
        :format="format"
      />
    </div>
    <div class="col-12 col-md-4 col-xl-2 mb-3">
      <label class="form-label text-theme">Fecha de alta</label>
      <VueDatePicker
        locale="es"
        cancelText="Cancelar"
        selectText="Seleccionar"
        :enable-time-picker="false"
        :format-locale="es"
        format="dd/MM/yyyy"
        v-model="fechaAlta"
        input-class-name="dp-custom-input"
      ></VueDatePicker>
    </div>
    <div class="col-12 col-md-4 col-xl-2 mb-3">
      <label class="form-label text-theme">Fecha de modificación</label>
      <VueDatePicker
        locale="es"
        cancelText="Cancelar"
        selectText="Seleccionar"
        :enable-time-picker="false"
        :format-locale="es"
        format="dd/MM/yyyy"
        v-model="fechaModificacion"
        input-class-name="dp-custom-input"
      ></VueDatePicker>
    </div>
    <div class="col-12 col-md-4 col-xl-2 mb-3">
      <label class="form-label text-theme">Número</label>
      <input class="form-control" v-model="numero" />
    </div>
    <div class="col-12 col-md-8 col-xl-4 mb-3">
      <label class="form-label text-theme">Creador</label>
      <vue-select
        :options="['Creador 1', 'Creador 2', 'Creador 3']"
        placeholder="-- Seleciona una opción --"
        v-model="creadorSeleccionado"
      ></vue-select>
    </div>
  </div>
  <div class="row">
    <div class="col-12 col-md-8 col-xl-4 mb-3">
      <label class="form-check-label text-theme" for="checkboxVerFichero"
        >Rango de importes</label
      >
      <NumericRangeInput
        @update-range="handleRangeUpdate"
        :clear="clearNumericRangeInput"
      />
    </div>
    <div class="col-12 col-md-8 col-xl-4 mb-3">
      <label class="form-label text-theme">Modificador</label>
      <vue-select
        :options="['Modificador 1', 'Modificador 2', 'Modificador 3']"
        placeholder="-- Seleciona una opción --"
        v-model="modificadorSeleccionado"
      ></vue-select>
    </div>
    <div class="col-2 col-xl-1 form-check mt-4">
      <input
        class="form-check-input"
        type="checkbox"
        id="checkboxVerFichero"
        v-model="checkVerFichero"
      />
      <label class="form-check-label text-theme" for="checkboxVerFichero"
        >Ver fichero</label
      >
    </div>
    <div class="col-2 col-xl-1 form-check mt-4">
      <input
        class="form-check-input"
        type="checkbox"
        id="checkboxSinFichero"
        v-model="checkSinFichero"
      />
      <label class="form-check-label text-theme" for="checkboxSinFichero"
        >Mostrar sin fichero</label
      >
    </div>
  </div>

  <p class="text-end mb-0">
    <a href="javascript:;" class="btn btn-white me-5px" @click="clearForm"
      >Borrar</a
    >
    <a href="javascript:;" class="btn btn-theme">Consultar</a>
  </p>
</template>
<script setup lang="ts">
import { ref } from "vue";
// datepicker
import VueDatePicker from "@vuepic/vue-datepicker";
import datepicker from "@/components/plugins/Datepicker.vue";
import "@vuepic/vue-datepicker/dist/main.css";
import { es } from "date-fns/locale";
// select
import vueSelect from "@/components/plugins/VueSelect.vue";
import NumericRangeInput from "./NumericRangeInput.vue";
// v-models
const fechaAlta = ref();
const fechaModificacion = ref();
const numero = ref();
const creadorSeleccionado = ref();
const modificadorSeleccionado = ref();
const checkVerFichero = ref(false);
const checkSinFichero = ref(false);
const rangoFechas = ref<Date[] | null>(null);
const format = () => {
  const fechas = rangoFechas.value;
  const fechasConvertidas: string[] = [];
  if (fechas !== null && fechas.length > 0) {
    if (fechas[1] !== null) {
      fechas.forEach((fecha: Date) => {
        const fechaObjeto = new Date(fecha);
        const fechaFormateada = fechaObjeto.toLocaleDateString("es-ES", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        });
        fechasConvertidas.push(fechaFormateada);
      });
      const fecha1 = fechasConvertidas[0];
      const fecha2 = fechasConvertidas[1];
      return `Rango entre ${fecha1} y ${fecha2}`;
    } else {
      let fechaObjeto = new Date(fechas[0]);
      let fechaFormateada = fechaObjeto.toLocaleDateString("es-ES", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
      return `${fechaFormateada}`;
    }
  }
};
// v-on del input de rango de importes
const selectedRange = ref<{ desde: number | null; hasta: number | null }>({
  desde: null,
  hasta: null,
});
const handleRangeUpdate = (range: { desde: number; hasta: number }) => {
  selectedRange.value = range;
  console.log(
    "Rango de importes Seleccionado: " + "desde: " + selectedRange.value.desde,
    "hasta: " + selectedRange.value.hasta,
  );
};
// flag para borrar el input de rango de importes
const clearNumericRangeInput = ref<number>(0);
// borrado del formulario
const clearForm = () => {
  fechaAlta.value = null;
  fechaModificacion.value = null;
  numero.value = null;
  creadorSeleccionado.value = null;
  modificadorSeleccionado.value = null;
  checkVerFichero.value = false;
  checkSinFichero.value = false;
  rangoFechas.value = null;
  selectedRange.value = { desde: null, hasta: null };
  clearNumericRangeInput.value++;
};
</script>
<style lang="scss">
/* estilo del input del datepicker, para que sea igual al form-control */
.dp-custom-input {
  display: block;
  width: 100%;
  padding: 0.4375rem 2rem;
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1.5;
  color: var(--bs-component-color);
  appearance: none;
  background-color: var(--bs-component-bg);
  background-clip: padding-box;
  border: 1px solid var(--bs-component-border-color);
  border-radius: 4px;
  transition:
    border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
}
/* color de las labels de los inputs */
.labelColor {
  color: #6a7177;
}
</style>
